import { string, ref } from 'yup';

// Define common validation rules for authentication fields
const authValidationRules = {
  name: string() // line break for readability
    .required('validations.valRequired'),

  lastName: string() // line break for readability
    .required('validations.valRequired'),

  email: string() // line break for readability
    .required('validations.valRequired')
    .email('validations.valEmailValid'),

  password: string()
    .required('validations.valRequired') // eslint-disable-next-line
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, 'validations.valPwdRule'),

  confirmPassword: string()
    .required('validations.valRequired')
    .oneOf([ref('password')], 'validations.valPwdMustMatch'),

  passwordRequiredOnly: string() // line break for readability
    .required('validations.valRequired')
};

// Rules for the registration form (using the common auth rules)
const registerValidationRules = {
  name: authValidationRules.name,
  lastName: authValidationRules.lastName,
  email: authValidationRules.email,
  password: authValidationRules.password,
  confirmPassword: authValidationRules.confirmPassword
};

// Rules for the login form (just need email and password)
const loginValidationRules = {
  email: authValidationRules.email,
  password: authValidationRules.passwordRequiredOnly
};

export { registerValidationRules, loginValidationRules };
